// Wortwolke und Tabelle (Jan 17.10.2026): Die Engine MISST die Wörter bzw.
// Spaltenbreiten mit der echten
// Schrift (canvas.measureText, s. infographicSvg wortMasse). Ist eine Schrift
// beim Bau noch nicht geladen, misst der Browser die Ersatzschrift — sobald die
// richtige kommt, wären die Wörter breiter oder schmaler als ihr Platz und
// überlappten. Deshalb wird eine Wolke erst gebaut, wenn ihre Schriften da
// sind (höchstens WARTEZEIT_MS lang, dann mit dem, was da ist).
import type { InfographicContent } from "@scrolly/post-types";
import { infografikMessSchriften, wortwolkenSchriftStapel } from "./infographicSvg";

const WARTEZEIT_MS = 4000;
// Je Schrift-Satz: geladen (oder Frist um) — und das laufende Laden selbst.
// NICHT document.fonts.check als Maßstab: Editor und Leser hinterlegen
// dieselben @font-face-Regeln doppelt, und check() bleibt dann false, obwohl
// die Schrift längst gezeichnet wird (gemessen im Pro-Editor, 17.10.2026).
const geladen: Record<string, boolean> = {};
const laden: Record<string, Promise<void>> = {};

function angaben(content: InfographicContent): string[] {
    return infografikMessSchriften(content)
        .filter((s) => s.family)
        .map((s) => `${s.weight} 100px ${wortwolkenSchriftStapel(s.family)}`)
        .filter((a, i, alle) => alle.indexOf(a) === i);
}

function ohneBrowser(content: InfographicContent): boolean {
    return (
        (content.chartType !== "wordcloud" && content.chartType !== "table" && content.chartType !== "steps") ||
        typeof document === "undefined" ||
        !document.fonts
    );
}

/** Schriften der Wolke laden (einmal je Schrift-Satz, höchstens WARTEZEIT_MS). */
export function ladeWortwolkenSchriften(content: InfographicContent): Promise<void> {
    if (ohneBrowser(content)) return Promise.resolve();
    const liste = angaben(content);
    const schluessel = liste.join("|");
    if (!liste.length || geladen[schluessel]) return Promise.resolve();
    if (!laden[schluessel]) {
        const alle = Promise.all(liste.map((a) => document.fonts.load(a).catch(() => undefined)));
        const frist = new Promise((fertig) => setTimeout(fertig, WARTEZEIT_MS));
        laden[schluessel] = Promise.race([alle, frist]).then(() => {
            geladen[schluessel] = true;
        });
    }
    return laden[schluessel];
}

/**
 * Sind die Schriften der Wolke geladen? Wenn nicht: `false` und Laden
 * anstoßen — der Aufrufer baut nach `ladeWortwolkenSchriften(...)` neu
 * (der Editor zeichnet nur bei Änderungen, ein „nächster Frame" kommt nicht
 * von selbst). Keine Wolke, keine Schriftwahl oder kein Browser: `true`.
 */
export function wortwolkenSchriftenBereit(content: InfographicContent): boolean {
    if (ohneBrowser(content)) return true;
    const liste = angaben(content);
    if (!liste.length || geladen[liste.join("|")]) return true;
    void ladeWortwolkenSchriften(content);
    return false;
}
